/**
 * Utility to safely initialize Sentry in both client and server environments
 */
export function initializeSentry() {
	// Check if we're in a browser environment
	if (typeof window !== "undefined") {
		// We're in a browser, Sentry can be initialized normally
		return true;
	}

	// We're in Node.js, provide a mock for 'self'
	if (typeof global !== "undefined" && !global.self) {
		// @ts-ignore - Adding self to global
		global.self = global;
	}
	return true;
}
